import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomApplyAiMappingAdditionalCostsMutation } from "generated/graphql";

export const useApplyAiMappingAdditionalCosts = () => {
  const [mutation, { data, loading, error }] = useCustomApplyAiMappingAdditionalCostsMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "applyAiMappingAdditionalCosts" },
    { hideMessage: true }
  );
};
